export const PACKAGE_NAME = 'jiraNavigationAppsSidebarNav4Projects';
export const TEAM_NAME = 'jira-cosmos';
